module.exports = __webpack_public_path__ + "media/images/shop/shop-cover-90777fa3f05561871a1e453e1ab0b99b.jpeg";